export default __webpack_public_path__ + "static/media/rhino.77a90b26.gif";